<template>
    <svg width="50px" height="50px">
        <circle class="progress-circle" cx="25" cy="25" r="20" fill="transparent" stroke="green" stroke-width="3" :stroke-dashoffset="progres" />
    </svg>
</template>
<style scoped>
    .progress-circle {
        stroke-dasharray: 125;
        /* stroke-dashoffset: 125; */
    }
</style>
<script>
    export default {
        props: {
            progress: Number
        },
        computed: {
            progres: function() {
                return this.progress
            }
        },
        mounted() {
            console.log('Hello World')
            this.progres = this.progress
            // this.$nextTick(() =>{
            //     console.log(this.progress)
            //     let fakeUploadPer = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            //     let circle = document.querySelector('.progress-circle')
            //     let circumference = 125
            //     let i = 0
    
            //     circle.style.strokeDashoffset = this.progres
            // })
            // setInterval(function() {
            //     let stroke = circumference - (fakeUploadPer[i] / 100) * circumference
            //     circle.style.strokeDashoffset = stroke
            //     i++
            //     console.log(stroke)
            // }, 1000)
        }
    }
</script>